import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './CountCard.module.css';

const CountCard = ({
  value,
  label,
  animated = true,
  duration = 600,
  className = '',
  valueClassName = '',
  labelClassName = '',
  disablePluralization = false,
}) => {
  const countRef = useRef(null);

  useEffect(() => {
    if (!animated || !countRef.current) return;

    const finalValue = parseInt(value) || 0;
    let currentValue = 0;
    const increment = Math.ceil(finalValue / 30);

    const counter = setInterval(() => {
      currentValue += increment;
      if (currentValue >= finalValue) {
        currentValue = finalValue;
        clearInterval(counter);
      }
      if (countRef.current) {
        countRef.current.textContent = currentValue;
      }
    }, duration / 30);

    return () => clearInterval(counter);
  }, [value, animated, duration]);

  return (
    <div className={`${styles.countCard} ${className}`}>
      <div ref={countRef} className={`${styles.countNumber} ${valueClassName}`}>
        {animated ? 0 : value}
      </div>
      <div className={`${styles.countLabel} ${labelClassName}`}>
        {label}
        {disablePluralization ? '' : (value === 1 ? '' : 's')}
      </div>
    </div>
  );
};

CountCard.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
  animated: PropTypes.bool,
  duration: PropTypes.number,
  className: PropTypes.string,
  valueClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  disablePluralization: PropTypes.bool,
};

export default CountCard;
